interface DeviceInfo {
  userAgent: string;
  platform: string;
  screenResolution: string;
  language: string;
}

export const extractDeviceInfo = async (): Promise<DeviceInfo> => {
  const userAgent = navigator.userAgent;
  let platform = "Unknown";

  if ("userAgentData" in navigator && navigator.userAgentData) {
    const userAgentData: any = navigator.userAgentData;
    platform = userAgentData?.platform;
  } else {
    // Fallback method to determine platform from userAgent
    if (userAgent.includes("Win")) platform = "Windows";
    else if (userAgent.includes("Mac")) platform = "macOS";
    else if (userAgent.includes("Linux")) platform = "Linux";
    else if (userAgent.includes("Android")) platform = "Android";
    else if (userAgent.includes("iOS")) platform = "iOS";
  }
  const screenResolution = `${window.screen.width}x${window.screen.height}`;
  const language = navigator.language;
  return {
    userAgent,
    platform,
    screenResolution,
    language,
  };
};
